import { createFileRoute } from '@tanstack/react-router';

// テストセット詳細 > 対象チケットの編集画面。
// URL search は持たない(候補ダイアログ内検索はローカル state で完結)ため
// ここではルート定義のみ。コンポーネントは index.lazy.tsx で遅延ロードする。
export const Route = createFileRoute('/_stacktrace/test-sets/$id/_layout/target-tickets/edit/')({});